// extracted by mini-css-extract-plugin
export default {"heading":"styles__heading__c547ca2d47bd01d4cad0","hidden":"styles__hidden__e15ef661829b10c98b21"};